import React from "react";
import { TableColumn } from 'react-data-table-component';
import DataGrid from "../../../Component/DataGrid/DataGrid";
import UserDetailsService from "../../../Services/UserDetailsService";
import moment from "moment";
import { StatusHistoryProps, StatusHistoryState, IStatusHistoryDetails } from "./Interface";
import { Status, UserStatus } from '../../../Component/Reusables/Utility';

class StatusHistory extends React.Component<StatusHistoryProps, StatusHistoryState> {
    private tableColumns: TableColumn<IStatusHistoryDetails>[] = [
        {
            name: 'User Name',
            selector: row => row.user_name,
            sortable: false,
            id: "UserName"
        },
        {
            name: 'User Email',
            selector: row => row.user_email,
            sortable: false,
            id: "UserEmail"
        },
        {
            name: 'Admin Name',
            selector: row => row.admin_name,
            sortable: false,
            id: "AdminName"
        },
        {
            name: 'User Status',
            selector: row => row.user_status,
            sortable: false,
            id: "UserStatus",
            cell: (row) => {
                return <span className={`status-label ${row.user_status.toLowerCase()}`}>{row.user_status}</span>;
            },
            center: true
        },
        {
            name: 'Created Date',
            selector: row => moment(row.created_date).format('MM-DD-YYYY hh:mm A'),
            sortable: true,
            id: "CreatedDate"
        },
        {
            name: 'Modified Date',
            selector: row => moment(row.modified_date).format('MM-DD-YYYY hh:mm A'),
            sortable: true,
            id: "ModifiedDate"
        }
    ];

    constructor(props: StatusHistoryProps) {
        super(props);
        this.state = {
            data: [],
            currentPage: 1,
            currentRowsPerPage: 10,
            totalRows: 100,
            searchText: "",
        }
    }

    public componentDidMount(): void {
        this.getStatusHistory();
    }

    private getStatusHistory() {
        let pageIndex: number = (this.state.currentPage - 1);
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage,
        };
        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText
        }
        UserDetailsService.getUserStatus(this.props.accessToken, pagination, this.props.userId).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    this.setState({
                        data: resp.userStatusList.map((status: any) => ({
                            user_name: status.userName,
                            user_email: status.email,
                            admin_name: status.adminName,
                            user_status: (parseInt(status.userStatus) === UserStatus.ACTIVE ? Status.ACTIVE :
                                parseInt(status.userStatus) === UserStatus.BLOCKED ? Status.BLOCKED :
                                    Status.UNKNOWN),
                            created_date: status.createdDate,
                            modified_date: status.modifiedDate,
                            user_status_id: status.statusId,
                        })),
                        totalRows: resp.pageCount
                    })
                });
            }
        });
    }

    public render() {
        return (
            <>
                <DataGrid
                    gridId="StatusHistory"
                    columns={this.tableColumns}
                    data={this.state.data}
                    defaultSearch={this.state.searchText}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getStatusHistory();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                        this.setState({
                            currentRowsPerPage: currentRowsPerPage_,
                            currentPage: currentPage_
                        }, () => {
                            this.getStatusHistory();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getStatusHistory();
                        })
                    }}
                    pagination
                    exportCsv={this.state.data.length ? true : false}
                    paginationTotalRows={this.state.totalRows} />
            </>
        )
    }
}

export default StatusHistory;